// extracted by mini-css-extract-plugin
export var notificationHost = "_i2-0";